module.exports = __webpack_public_path__ + "je.svg?12bf2a5fe22bbdbcf5b5187920ed633e";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/1x1/je.svg
// module id = 1176
// module chunks = 0